<template>
  <router-link
    class="product-card"
    :to="{ name: 'ProductDetail', query: { id: item.id } }">
    <div class="thumb">
      <img v-bind:src="item.downloadUrl" alt="" loading="lazy" decoding="async">
    </div>
    <div class="body">
      <div class="title">{{ item.title }}</div>
      <span class="detail-btn">詳細を見る</span>
    </div>
  </router-link>
</template>

<script>
export default {
  data() {
    return {
      item: {}
    }
  },
  props: {
    value: String
  },
  mounted() {
    this.item = JSON.parse(this.value);
    if (this.item.imageurl) {
      const bucket = "farmy-demo.appspot.com";
      const path = encodeURIComponent("products-contents-image/" + this.item.imageurl);
      this.item.downloadUrl = `https://firebasestorage.googleapis.com/v0/b/${bucket}/o/${path}?alt=media`;
    }
  }
}
</script>

<style scoped>
.product-card {
  display: block;
  width: 100%;
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  text-decoration: none;
  color: inherit;
  transition: transform 0.2s, box-shadow 0.2s;
}
.product-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.14);
}
.thumb {
  position: relative;
  aspect-ratio: 16 / 10;
  overflow: hidden;
  background: #f0ece1;
}
.thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.4s ease;
}
.product-card:hover .thumb img {
  transform: scale(1.06);
}
.body {
  padding: 14px 16px 18px;
  text-align: left;
}
.title {
  color: #433f38;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  min-height: 45px;
  margin-bottom: 16px;
}
.detail-btn {
  display: block;
  text-align: center;
  background: #AF9453;
  color: #fff;
  padding: 9px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  transition: filter 0.15s;
}
.product-card:hover .detail-btn {
  filter: brightness(1.08);
}
</style>
